/* eslint-disable arrow-body-style */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Result, ResultsStatus } from '@src/common/types';
import { ajax } from '@src/common/ajax';
import { ApiUrl } from '@src/common/ajax/apiUrl';
import { getResultStatus } from '@src/common/util/getResultStatus';
import { LaFilterPanelState, LaNodeApiItem, LaNodesResponse } from '../types';
import { laFilterPanelToHash } from '../mothership/laFilterPanelToHash';

interface Props {
  nodeIds: string[];
  fpState: LaFilterPanelState;
}

const cache: Record<string, LaNodeApiItem[]> = {};

export async function laFetchNodes({
  fpState,
  nodeIds,
}: Props): Promise<Result<LaNodeApiItem[]>> {
  const cacheKey = laFilterPanelToHash(fpState, 0);
  const cachedResult = cache[cacheKey];
  if (cachedResult && cachedResult.length) {
    return {
      resultStatus: ResultsStatus.results,
      result: cachedResult,
    };
  }

  const chunkSize = 250;

  const nodeIdChunks = splitEdges(nodeIds, chunkSize);
  const resultFlags: ResultsStatus[] = [];
  const resultNodes: LaNodeApiItem[] = [];
  const fetchFns = nodeIdChunks.map((chunk) => fetchNodes(chunk));
  const resultChunks = await Promise.all(fetchFns);
  resultChunks.forEach((chunkResult) => {
    resultFlags.push(chunkResult.resultStatus);
    chunkResult.result.forEach((node) => resultNodes.push(node));
  });

  const hasError = resultFlags.some((result) => result === ResultsStatus.error);
  const isEmpty = resultNodes.length === 0;

  let resultStatus = ResultsStatus.results;
  if (hasError) {
    resultStatus = ResultsStatus.error;
  } else if (isEmpty) {
    resultStatus = ResultsStatus.noResults;
  }

  if (resultStatus === ResultsStatus.results) {
    cache[cacheKey] = resultNodes;
  }

  return {
    resultStatus,
    result: resultNodes,
  };
}

async function fetchNodes(nodeIds: string[]) {
  const { success, payload } = await ajax<LaNodesResponse>(
    { content: [] },
    ApiUrl.laNodes,
    { method: 'post', body: JSON.stringify({ nodeIds }) }
  );

  const resp: Result<LaNodeApiItem[]> = {
    resultStatus: getResultStatus(success, payload.content),
    result: payload.content,
  };

  return resp;
}

export function splitEdges(edges: string[], chunkSize: number) {
  const chunks: string[][] = [];
  for (let i = 0; i < edges.length; i += chunkSize) {
    chunks.push(edges.slice(i, i + chunkSize));
  }
  return chunks;
}
